import {getCategories} from '@/api/categories.js'

export default {
  state: {
    categories: [],
  },
  getters: {
    getCategoryById: (state) => (categoryId) => {
      for (let categoryGroup of state.categories) {
        for (let category of categoryGroup.list) {
          if (category.id == categoryId) {
            return category;
          }
        }
      }
    },
  },
  mutations: {
    setCategories(state, categories) {
      state.categories = categories;
    },
  },
  actions: {
    requestCategories({commit}) {
      return new Promise(function(resolve, reject) {
        getCategories().then(function(categories) {
          commit('setCategories', categories);
          resolve();
        });
      });
    },
  },
}


// WEBPACK FOOTER //
// ./src/store/categories.js